var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-select',{attrs:{"dense":"","outlined":"","hide-details":"","multiple":"","items":_vm.options},on:{"blur":_vm.handleClose},model:{value:(_vm.profileArr),callback:function ($$v) {_vm.profileArr=$$v},expression:"profileArr"}})
}
var staticRenderFns = []

export { render, staticRenderFns }